import axios, { CancelToken, isCancel } from "axios";
import moment from "moment";
import jwt from "jsonwebtoken";
import * as XLSX from "xlsx";

// const validateProperty = (item,index, propertyName, displayName, errorList) => {
//   if (!item[propertyName] ) {
//     const err = `The value of ${displayName} at row ${index + 2} is missing`;
//
//     errorList.push(err);
//   } else {
//     item[propertyName] = item[propertyName]?.toString() || "";
//   }
// };
// const batchExcelUploadFile = async (

//     worksheet,
//     additionalAttachmentRef,
//     noOfLoops,
//     setErrorMessage,
//     setSuccessMessage,
//     setAttchmentLoader,
//     setAlertList,
//     setAlertMessage
//   ) => {
// setAttchmentLoader(true)
//     let {
//       A1,AA1,AB1,AC1,AD1,AE1,AF1,AG1,AH1, B1, C1,
//       D1, E1, F1, G1, H1, I1, J1, K1, L1, M1,N1,
//       O1,P1,Q1,R1,S1,T1,U1,V1,W1,X1,Y1,Z1

//     } = worksheet;

//     const json = XLSX.utils.sheet_to_json(worksheet);
//
//     const propertyValidations = Object.keys(json[0]).map(propertyName => ({
//       property: propertyName,
//       displayName: propertyName,
//     }));
//
//     let temp = [];
//
//     let errorList = [];
//     let wrongFile = false;
//     for (let i = 0; i < json.length; i++) {
//       const item = json[i];
//       // propertyValidations.forEach(({ property, displayName }) => {
//       //   validateProperty(item, i,property, displayName, errorList);
//       // });
//       if (!item?.PaymentRef) {
//         // wrongFile = true;
//         const err = `The value  of PaymentRef at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.PaymentRef= item?.PaymentRef?.toString() || "";
//       }
//       if (!item?.SourceFund) {
//         // wrongFile = true;
//         const err = `The value  of SourceFund at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.SourceFund = item?.SourceFund?.toString() || "";
//       }
//       if (!item?.IsProcessed) {
//         // wrongFile = true;
//         const err = `The value  of IsProcessed at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.IsProcessed = item?.IsProcessed?.toString() || "";
//       }
//       if (!item?.IsArchived) {
//         // wrongFile = true;
//         const err = `The value  of IsArchived at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.IsArchived = item?.IsArchived?.toString() || "";
//       }

//       if (!item?.ArchivedDate) {
//         const err = `The value of ArchivedDate at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         let aDate = moment(item.ArchivedDate, "DD/MM/YYYY", true);
//         let isValid = aDate.isValid();
//         if (isValid) {
//           item.ArchivedDate = aDate.format("YYYY-MM-DD");
//         } else {
//           const err = `ArchivedDate at row ${i + 2} is invalid`;
//           errorList.push(err);
//         }
//       }
//       if (!item?.CreatedDate) {
//         const err = `The value of CreatedDate at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         let aDate = moment(item.CreatedDate, "DD/MM/YYYY", true);
//         let isValid = aDate.isValid();
//         if (isValid) {
//           item.CreatedDate = aDate.format("YYYY-MM-DD");
//         } else {
//           const err = `CreatedDate at row ${i + 2} is invalid`;
//           errorList.push(err);
//         }
//       }

//       if (!item?.ModifiedDate) {
//         const err = `The value of ModifiedDate at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         let aDate = moment(item.ModifiedDate, "DD/MM/YYYY", true);
//         let isValid = aDate.isValid();
//         if (isValid) {
//           item.ModifiedDate = aDate.format("YYYY-MM-DD");
//         } else {
//           const err = `ModifiedDate at row ${i + 2} is invalid`;
//           errorList.push(err);
//         }
//       }
//       if (!item?.Location) {
//         // wrongFile = true;
//         const err = `The value  of Location at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.Location = item?.Location?.toString() || "";
//       }
//       if (!item?.BatchRef) {
//         // wrongFile = true;
//         const err = `The value  of BatchRef at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.BatchRef = item?.BatchRef?.toString() || "";
//       }
//       if (!item?.CustomerRef) {
//         // wrongFile = true;
//         const err = `The value  of CustomerRef at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.CustomerRef = item?.CustomerRef?.toString() || "";
//       }
//       if (!item?.Status) {
//         // wrongFile = true;
//         const err = `The value  of Status at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.Status = item?.Status?.toString() || "";
//       }
//       if (!item?.ImportRef) {
//         // wrongFile = true;
//         const err = `The value  of ImportRef at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.ImportRef = item?.ImportRef?.toString() || "";
//       }
//       if (!item?.Type) {
//         // wrongFile = true;
//         const err = `The value  of Type at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.Type = item?.Type?.toString() || "";
//       }
//       if (!item?.AccountName) {
//         // wrongFile = true;
//         const err = `The value  of AccountName at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.AccountName = item?.AccountName?.toString() || "";
//       }

//       if (!item?.Account) {
//         // wrongFile = true;
//         const err = `The value  of Account at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.invoice_Amount = item?.invoice_Amount?.toString() || "";
//       }

//       if (!item?.DebitDate) {
//         const err = `The value of DebitDate at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         let aDate = moment(item.DebitDate, "DD/MM/YYYY", true);
//         let isValid = aDate.isValid();
//         if (isValid) {
//           item.DebitDate = aDate.format("YYYY-MM-DD");
//         } else {
//           const err = `DebitDate at row ${i + 2} is invalid`;
//           errorList.push(err);
//         }
//       }
//       if (!item?.PaymentDate) {
//         const err = `The value of PaymentDate at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         let aDate = moment(item.PaymentDate, "DD/MM/YYYY", true);
//         let isValid = aDate.isValid();
//         if (isValid) {
//           item.PaymentDate = aDate.format("YYYY-MM-DD");
//         } else {
//           const err = `PaymentDate at row ${i + 2} is invalid`;
//           errorList.push(err);
//         }
//       }
//       if (!item?.Currency) {
//         // wrongFile = true;
//         const err = `The value  of Currency at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.Currency = item?.Currency?.toString() || "";
//       }
//       if (!item?.TotalAmountPaymentCurrency) {
//         // wrongFile = true;
//         const err = `The value  of TotalAmountPaymentCurrency at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.TotalAmountPaymentCurrency = item?.TotalAmountPaymentCurrency?.toString() || "";
//       }
//       if (!item?. ExchangeRate) {
//         // wrongFile = true;
//         const err = `The value  of  ExchangeRate at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item. ExchangeRate = item?.ExchangeRate?.toString() || "";
//       }
//       if (!item?.TotalAmountDebitCurrency) {
//         // wrongFile = true;
//         const err = `The value  of TotalAmountDebitCurrency at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.TotalAmountDebitCurrency = item?.TotalAmountDebitCurrency?.toString() || "";
//       }
//       if (!item?.DebitAccount) {
//         // wrongFile = true;
//         const err = `The value  of DebitAccount at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.DebitAccount = item?.DebitAccount?.toString() || "";
//       }

//       if (!item?.DebitAccountName) {
//         // wrongFile = true;
//         const err = `The value  of DebitAccountName at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.DebitAccountName = item?.DebitAccountName?.toString() || "";
//       }

//       if (!item?.DR_BCE) {
//         // wrongFile = true;
//         const err = `The value  of DR_BCE at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.DR_BCE = item?.DR_BCE?.toString() || "";
//       } if (!item?.DR_ACE) {
//         // wrongFile = true;
//         const err = `The value  of DR_ACE at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.DR_ACE = item?.DR_ACE?.toString() || "";
//       } if (!item?.PaymentPurpose) {
//         // wrongFile = true;
//         const err = `The value  of PaymentPurpose at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.PaymentPurpose = item?.PaymentPurpose?.toString() || "";
//       } if (!item?.BeneficiaryBankCode) {
//         // wrongFile = true;
//         const err = `The value  of BeneficiaryBankCode at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.BeneficiaryBankCode = item?.BeneficiaryBankCode?.toString() || "";
//       } if (!item?.DebitCurrency) {
//         // wrongFile = true;
//         const err = `The value  of DebitCurrency at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.DebitCurrency = item?.DebitCurrency?.toString() || "";
//       } if (!item?.LocalBankClearingCode) {
//         // wrongFile = true;
//         const err = `The value  of LocalBankClearingCode at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.LocalBankClearingCode = item?.LocalBankClearingCode?.toString() || "";
//       } if (!item?.BranchCode) {
//         // wrongFile = true;
//         const err = `The value  of BranchCode at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.BranchCode = item?.BranchCode?.toString() || "";
//       }
//       if (!item?.CreationDate) {
//         const err = `The value of CreationDate at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         let aDate = moment(item.CreationDate, "DD/MM/YYYY", true);
//         let isValid = aDate.isValid();
//         if (isValid) {
//           item.CreationDate = aDate.format("YYYY-MM-DD");
//         } else {
//           const err = `CreationDate at row ${i + 2} is invalid`;
//           errorList.push(err);
//         }
//       }
//       if (!item?.BeneficiaryIdentityType) {
//         // wrongFile = true;
//         const err = `The value  of BeneficiaryIdentityType at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.BeneficiaryIdentityType = item?.BeneficiaryIdentityType?.toString() || "";
//       } if (!item?.BeneficiaryIdentity) {
//         // wrongFile = true;
//         const err = `The value  of BeneficiaryIdentity at row ${i + 2} is missing`;
//
//         errorList.push(err);
//       } else {
//         item.BeneficiaryIdentity = item?.BeneficiaryIdentity?.toString() || "";
//       }

//       temp.push(item);

//     }

//     if (errorList.length == 0){
//         await axios({
//             method: "post", //you can set what request you want to be
//             url: `${process.env.REACT_APP_API_URL}api/Signatory/UploadBatches`,
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("user_token")}`,
//               "Content-Type": "application/json",
//             },
//           })
//             .then(async (res) => {
//
//               additionalAttachmentRef.current.value = null;

//               setAttchmentLoader(false);
//             })
//             .catch((err) => {
//
//               additionalAttachmentRef.current.value = null;

//             });
//     }else{
//         setAlertMessage(true);
//         setAlertList(errorList);
//         setAttchmentLoader(false);
//     }

//   };
const batchExcelUploadFile = async (
  fileName,
  worksheet,
  additionalAttachmentRef,
  noOfLoops,
  setErrorMessage,
  setSuccessMessage,
  setAttchmentLoader,
  setAlertList,
  setAlertMessage,
  getBtachesData,
  cancelfileUpload,
  setExcelFile
) => {
  setAttchmentLoader(true);

  let { A1, B1, C1, D1, E1, F1 } = worksheet;
  // const file = e.target.files?.[0]
  //

  let wrongFile = false;
  // const maxColumns = 5;
  // if (worksheet['!ref']) {
  //   const range = XLSX.utils.decode_range(worksheet['!ref']);
  //
  //   if (range.e.c > maxColumns || range.e.c < maxColumns) {
  //     setErrorMessage(`you try to upload an Invalid File`);
  //     setAttchmentLoader(false);
  //     additionalAttachmentRef.current.value = null;
  //     return;
  //   }
  // }
  if (A1 && B1 && C1 && D1 && E1 && F1) {
    A1.v = "CHQ";
    A1.w = "CHQ";
    B1.v = "Doc Number";
    B1.w = "Doc Number";
    C1.v = "Pmnt date";
    C1.w = "Pmnt date";
    D1.v = "Amount paid";
    D1.w = "Amount paid";
    E1.v = "Recipient";
    E1.w = "Recipient";
    F1.v = "Batch No";
    F1.w = "Batch No";
  } else {
    wrongFile = true;
  }
  const json = XLSX.utils.sheet_to_json(worksheet);

  let temp = [];

  let errorList = [];

  for (let i = 0; i < json.length; i++) {
    const item = json[i];
    const list = {};
    const rowValues = Object.keys(item);

    if (
      !item?.["Amount paid" || "Amountpaid"] ||
      item?.["Amount paid" || "Amountpaid"] === "Null"
    ) {
      // wrongFile = true;
      const err = `The value  of Amount paid at row ${
        i + 2
      } is missing or Null `;

      errorList.push(err);
    } else {
      list.totalAmountPaymentCurrency =
        item?.["Amount paid"].toString() || item?.Amountpaid?.toString() || "";
    }
    if (!item?.["Batch No"] || item?.["Batch No"] === "Null") {
      // wrongFile = true;
      const err = `The value  of Batch No at row ${i + 2} is missing or Null`;

      errorList.push(err);
    } else {
      // item.BatchNo = item?.['Batch No'] ||  item?.BatchNo?.toString() || "";
      list.batchRef = item?.["Batch No"] || item?.BatchNo?.toString() || "";
    }
    if (!item?.CHQ || item?.CHQ === "Null") {
      // wrongFile = true;
      const err = `The value  of CHQ at row ${i + 2} is missing or Null`;

      errorList.push(err);
    } else {
      // item.CHQ = item?.CHQ?.toString() || "";
      list.paymentRef = item?.CHQ?.toString() || "";
    }
    if (
      !item?.["Doc Number" || "DocNumber"] ||
      !item?.["Doc Number" || "DocNumber"] === "Null"
    ) {
      // wrongFile = true;
      const err = `The value  of Doc Number at row ${i + 2} is missing or Null`;

      errorList.push(err);
    } else {
      // item.DocNumber =  item?.['Doc Number'] || item?.DocNumber?.toString() || "";

      list.customerRef =
        item?.["Doc Number"].toString() || item?.DocNumber?.toString() || "";
    }
    if (
      !item?.["Pmnt date" || "Pmntdate"] ||
      !item?.["Pmnt date" || "Pmntdate"] === "Null"
    ) {
      const err = `The value of Pmnt date at row ${i + 2} is missing or Null`;

      errorList.push(err);
    } else {
      let excelDateValue = item["Pmnt date" || "Pmntdate"]; // Extract the payment date value
      let date;
      if (typeof excelDateValue === "number") {
        // Convert Excel date to JavaScript Date object
        let millisecondsPerDay = 24 * 60 * 60 * 1000;
        let excelEpoch = new Date(1899, 11, 30); // Excel epoch is December 30, 1899
        date = new Date(excelEpoch.getTime() + excelDateValue * millisecondsPerDay);
    console.log(date,"date")
        // Format the date using moment.js
        let year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0'); // JavaScript months are 0-indexed, so add 1
        let day = date.getDate().toString().padStart(2, '0');
    
        // Construct the date string in the desired format "YYYY-MM-DD"
        // this day and month swapping done due to wrong format 
        let formattedDate = `${year}-${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}`;
        list.paymentDate = formattedDate;
        console.log(formattedDate,"formattedDate")
    } else {
        // If the date is not a number, attempt parsing with moment.js
        let parsedDate = moment(excelDateValue, "DD.MM.YYYY", true);
          console.log(parsedDate,"parsedDate")
        if (parsedDate.isValid()) {
            // Format the valid date to "YYYY-MM-DD"
            list.paymentDate = parsedDate.format("YYYY-MM-DD");
        } else {
            const err = `The date format at row ${i + 2} is invalid`;
            errorList.push(err);
        }
    }
      // if (typeof excelDateValue === "number") {
      //   let millisecondsPerDay = 24 * 60 * 60 * 1000;
      //   let excelEpoch = new Date(1899, 11, 30); // Excel epoch is December 30, 1899
      //   date = new Date(
      //     excelEpoch.getTime() + excelDateValue * millisecondsPerDay
      //   );
      //   let formattedDate = moment(date).format("YYYY-MM-DD");
      //   list.paymentDate = formattedDate;
      //   console.log(formattedDate,"paymentDate")
      // } else {
      //   let parsedDate = moment(
      //     excelDateValue,
      //     ["DD.MM.YYYY", "MM/DD/YYYY", "YYYY-MM-DD"],
      //     true
      //   );
      //   console.log(parsedDate,"parsedDate")
      //   if (parsedDate.isValid()) {

      //     list.paymentDate = parsedDate.format("YYYY-MM-DD");
      //   } else {
      //     const err = `The date format at row ${i + 2} is invalid`;
      //     errorList.push(err);
      //   }
      //   //  let formattedDate = moment(excelDateValue).format("YYYY-MM-DD");
      //   //  list.paymentDate = formattedDate;
      // }
      // let  aDate = moment(excelDateValue, "DD.MM.YYYY", true);
      // let isValid = aDate.isValid();
      // if (isValid) {
      //   // item.Pmntdate = aDate.format("YYYY-MM-DD");
      //   list.paymentDate = aDate.format("YYYY-MM-DD");
      // } else {
      //   const err = `Pmntdate at row ${
      //     i + 2
      //   } is invalid the date format should be DD/MM/YYYY`;
      //   errorList.push(err);
      // }
    }

    if (!item?.Recipient === "Null") {
      // wrongFile = true;
      const err = `The value  of Recipient at row ${i + 2} is missing or Null`;

      errorList.push(err);
    } else {
      list.accountName = item?.Recipient?.toString() || "";
    }
    temp.push(list);
  }

  {
    if (errorList?.length === 0 && wrongFile === false) {
      const axiosConfig = {
        // ...
        cancelToken: new CancelToken(
          (cancel) => (cancelfileUpload.current = cancel)
        ),
      };
      setTimeout(async () => {
        await axios({
          method: "post", //you can set what request you want to be
          url: `${process.env.REACT_APP_API_URL}/api/Signatory/UploadBatches`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            "Content-Type": "application/json",
          },
          data: temp,
          ...axiosConfig,
        })
          .then(async (res) => {
            setSuccessMessage("file Uploaded successfully");
            additionalAttachmentRef.current.value = null;
            getBtachesData();
            setExcelFile(fileName?.name);
            setAttchmentLoader(false);
          })
          .catch((err) => {
            if (isCancel(err)) {
              setErrorMessage("File uploading has been cancelled");
              setAttchmentLoader(false);
            } else {
              if (err.response.data) {
                setErrorMessage(err.response.data);
              } else {
                setErrorMessage("Error while Uploading file");
              }
            }
            setAttchmentLoader(false);

            additionalAttachmentRef.current.value = null;
          });
      }, 4000);
    } else {
      if (wrongFile == true) {
        setErrorMessage("you try to upload an Invalid File");
        setAttchmentLoader(false);
      } else {
        setAlertMessage(true);
        setAlertList(errorList);
        setAttchmentLoader(false);
        additionalAttachmentRef.current.value = null;
      }
    }
  }
};
export { batchExcelUploadFile };
